<div class="vi-head flex flex-col justify-between items-stretch" [class.shadow]="isShadow">
  <ng-content></ng-content>
</div>
